/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pos_Checkout_Requires_DisplayInputs */

const vi_pos_checkout_requires_display = /** @type {(inputs: Pos_Checkout_Requires_DisplayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vui lòng chọn màn hình khách trước khi bán đơn chuyển khoản`)
};

/**

* @param {Pos_Checkout_Requires_DisplayInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_checkout_requires_display = /** @type {((inputs?: Pos_Checkout_Requires_DisplayInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Checkout_Requires_DisplayInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_checkout_requires_display(inputs)
});